module.exports = __webpack_public_path__ + "static/img/sapidoLOGO.7abaca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sapidoLOGO.png
// module id = sZ4v
// module chunks = 1